export default "__VITE_ASSET__BZpD25hX__"